import { DOCS_FORM_NAMES } from "core/consts";
import type { DocsFormDataMapped, Observation } from "core/types";
import type { MigratedForms } from "dsl/ecosystems/RecareDocs/Modal/utils";
import Translations from "translations/types";
import { FieldConfig } from "./pdfCreationUtils";
import { CARDIOLOGY_FIELD_CONFIG } from "./Cardiology/pdfCreator";
import { ENT_FIELD_CONFIG } from "./ENT/pdfCreator";

const FIELD_CONFIGS: Record<MigratedForms, Array<FieldConfig<MigratedForms>>> =
  {
    [DOCS_FORM_NAMES.DISCHARGE_LETTER_CARDIOLOGY]:
      CARDIOLOGY_FIELD_CONFIG as Array<FieldConfig<MigratedForms>>,
    [DOCS_FORM_NAMES.DISCHARGE_LETTER_ENT]: ENT_FIELD_CONFIG as Array<
      FieldConfig<MigratedForms>
    >,
  };

export function buildDischargeLetterObservation(
  formData: DocsFormDataMapped<MigratedForms>,
  formName: MigratedForms,
  translations: Translations,
  externalId: string,
): Observation {
  const nowUnix = Math.floor(Date.now() / 1000);
  const fieldConfig = FIELD_CONFIGS[formName];

  const nonEmptyFields = fieldConfig.filter((field) => {
    const value = formData[field.key];
    return value != null && String(value).trim() !== "";
  });

  return {
    request: {
      filler_order_id: { entity_id: externalId, namespace_id: "DOC" },
      observation_time: nowUnix,
      set_id: 1,
    },
    result: nonEmptyFields.map((field, index) => ({
      date_time: nowUnix,
      field_label: field.label(translations),
      field_name: String(field.key),
      observation_value: String(formData[field.key] ?? "").trim(),
      set_id: index + 1,
    })),
  };
}
